import { HTMLAttributes, ReactElement } from 'react';
import { stringMask } from '@/utils';

interface Props extends Omit<HTMLAttributes<HTMLSpanElement>, 'children'> {
  children: string;
}

export default function Username({ children, ...props }: Props): ReactElement {
  const isAnObjectId = /^(?=[a-f\d]{24}$)(\d+[a-f]|[a-f]+\d)/i.test(children);
  const isWalletId = /^0x[a-fA-F0-9]{40}$/i.test(children);

  return (
    <span title={children} {...props}>
      {isAnObjectId || isWalletId ? stringMask(children) : children}
    </span>
  );
}
